export type absorptionsData = {
  level: string;
  title: string;
  layersImage: string;
  layersText: string;
  pads: number;
  padsText: string;
};

export const allAbsorptionsData = [
  {
    level: "Strong",
    title: "strong_absorption_holds",
    layersImage: "1-absorption-layer.png",
    layersText: "strong_absorbing_layers",
    pads: 3,
    padsText: "absorbs_same_as_n_pads",
  },
  {
    level: "Strong +",
    title: "strong_plus_absorption_holds",
    layersImage: "2-absorption-layers.png",
    layersText: "strong_plus_absorbing_layers",
    pads: 4,
    padsText: "absorbs_same_as_n_pads",
  },
  {
    level: "Ultra",
    title: "ultra_absorption_holds",
    layersImage: "2-absorption-layers.png",
    layersText: "ultra_absorbing_layers",
    pads: 5,
    padsText: "absorbs_same_as_n_pads",
  },
];
